import React from 'react'
import Channel from './channel'

const Channels = ({channels, channelId, players, onPlayerSelected, onChannelSelected, onCloseChannel, setQuery}) => {
  const onSelectChannel = id => {
    const channel = channels.find(a => a.id == id)
    const player  = players.find(a => a.id == channel.player)

    onPlayerSelected({
      id: player && player.id,
      firstName: player && player.first_name,
      lastName: player && player.last_name,
      email: player && player.email,
      phone: player && player.phone,
      countryCode: player && player.country_code,
      name: player && `${player.first_name} ${player.last_name}` || 'Unknown',
      avatar: player && player.image_url || '/images/ic_user@2x.png',
      region: player && player.region,
      regionName: player && player.region_name,
      hasApp: player && player.has_app
    })

    onChannelSelected({ id: id })
    setQuery('')
  }

  return [
    <div key='header' className='messages-cell conversations-header'>All Conversations</div>,
    <div key='body' className='messages-cell conversations-body'>
      { channels && !channels.length && <div className='no-channels'>No available conversations</div> }
      { channels && !!channels.length &&
        <div className='channels-wrapper'>
          { channels.map(c =>
            <Channel
              key={c.id}
              id={c.player}
              player={players.find(a => a.id == c.player)}
              lastMessage={c.lastMessage}
              unseenCount={c.unseenCount}
              date={c.date?.toDate()}
              selected={c.id == channelId}
              onSelect={() => onSelectChannel(c.id)}
              onClose={() => onCloseChannel(c.id)}
            />
          )}
        </div>
      }
    </div>
  ]
}

export default Channels
